export const CHANGE_PAGE = 'stats/reports/payouts/transactions/CHANGE_PAGE';
export const changePage = page => ({ type: CHANGE_PAGE, page });

export const initialState = {
  page: 1,
};

export default (state = initialState, action) => {
  const { type, page } = action;

  switch (type) {
    case CHANGE_PAGE:
      return { ...state, page };
    default: {
      return state;
    }
  }
};
